import React from 'react'
import { FindUs } from '@scrippsproduct/scripps-external-component-library'

import './../scss/FindUs.scss'

function FindUsPage() {
    const adObjMap = new Map([
        ['production', {
            campaign: 'leadgen',
            source: 'ionmystery.com',
            medium: 'referral',
            content: 'findus_jessefantasy',
        }],
        ['staging', {
            campaign: 'staging',
            source: 'staging.ionmystery.com',
            medium: 'referral',
            content: 'findus_jessefantasy',
        }],
        ['local', {
            campaign: '',
            source: '',
                medium: '',
                content: '',
        }],
    ])

    return (<>    
        <content-constrainer class="content-constrainer--no-padding content-constrainer--no-border">
            <h2 className="page-content-header">FIND WHERE TO WATCH ION Mystery</h2>
            <div className='page-content-subheader'>Enter your Zip Code to find ION Mystery in your area, or select a streaming provider.</div>
        </content-constrainer>
        <FindUs 
            network={{
                brand_name: 'ION Mystery',
                slug: 'ion-mystery',
                platformsSlug: 'ionmystery',
            }}
            baseApiUrl={`${process.env.REACT_APP_AFFILIATES}`}
            allowStateSearch={false}
            allowZipcodeSearch={true}
            compactLayout={false}
            autoScrollOffset={25}
            ad={adObjMap.get(process.env.REACT_APP_ENV) ?? {
                campaign: '',
                source: '',
                medium: '',
                content: '',
            }}
        />
    </>)
}

export default FindUsPage